import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

let kejianrouter = new Router({
    mode: 'history',
    routes: [{
        path: '/',
        name: 'homePage',
        component: () => import('./views/HomePage.vue')
    },
    // {
    //     path: '/',
    //     name: 'homePage',
    //     component: () => import('./views/HomePage.vue')
    // },
   
]
});

export default kejianrouter;